import React, { useContext, useState} from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import CryptoContext from "../context/crypto/cryptoContext";
import ParameterContext from "../context/parameter/parameterContext";

import Loader1 from "../components/Loader1";
const SingleCryptoChart = ({ symbol, currencySymbol, localCurrency }) => {
  const loading = useState(false)[0];

  const {

    singleSparklineData,
    exchangeRate,
  } = useContext(CryptoContext);
  const { setTimeInChart, timeInChart } = useContext(ParameterContext);

  // useEffect(() => {
  //   // clearSparklines();
  //   // if(!sparklineData||!sparklineData.length>0)
  //   if (cryptoStr) {
  //     // setLoading(true)
  //     console.log(cryptoStr, sparklineData);
  //     setTimeout(() => getSparklines(symbol, "1d", localCurrency), 1000);
  //   }

  //   if (symbol) {
  //     setCryptostr(symbol);
  //   }
  // }, [timeInChart, cryptoStr, localCurrency]);
  let options = {
    chart: {
      type: "spline",
      zoomType: "xy",
    },
    title: {
      text: "",
    },

    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%e %b",
        week: "%e %b",
        month: "%b '%y",
        year: "%Y",
      },
    },
    yAxis: {
      labels: {
        formatter: function () {
          return (
            `${currencySymbol}` + this.axis.defaultLabelFormatter.call(this)
          );
        },
      },
      title: {
        text: "Price",
      },
    },

    credits: {
      enabled: false,
    },
    series: [
      {
        name: symbol,
        showInLegend: false,
        data:
          singleSparklineData &&
          singleSparklineData[0]?.currency === symbol &&
          singleSparklineData[0].timestamps.map((i, index) => {
            return [
              new Date(i).getTime(),
              Number(
                (singleSparklineData[0]?.prices[index] / exchangeRate).toFixed(
                  2
                )
              ),
            ];
          }),
      },
    ],
  };

  return (
    <div className="SingleCryptoChart">
      <div className="SingleCryptoChart__container">
        <header>
          <section className="SingleCryptoChart__header__left"></section>
          <section className="SingleCryptoChart__header__right">
            <div
              onClick={() => setTimeInChart("1d")}
              style={{ background: timeInChart === "1d" ? "white" : "" }}
            >
              1d
            </div>
            <div
              onClick={() => setTimeInChart("7d")}
              style={{ background: timeInChart === "7d" ? "white" : "" }}
            >
              7d
            </div>
            <div
              onClick={() => setTimeInChart("1m")}
              style={{ background: timeInChart === "1m" ? "white" : "" }}
            >
              1m
            </div>

            <div
              onClick={() => setTimeInChart("1y")}
              style={{ background: timeInChart === "1y" ? "white" : "" }}
            >
              1y
            </div>
            <div
              onClick={() => setTimeInChart("ally")}
              style={{ background: timeInChart === "ally" ? "white" : "" }}
            >
              All
            </div>
          </section>
        </header>
        {singleSparklineData[0]?.currency === symbol && (
          <section className="SingleCryptoChart__chart">
            <center>
              
              {loading && (
                <div className="SingleCryptoChart__overlay">
                  <Loader1 />
                  <p>Loading Data</p>
                  <p>Please wait until we load Chart Data</p>
                </div>
              )}
              <div className="SingleCryptoChart__watermark">
                Copyright © 2021 CoinStorey Pvt. Ltd. All rights reserved.
              </div>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </center>
          </section>
        )}
      </div>
    </div>
  );
};

export default SingleCryptoChart;
